export function extrairId(item: any): number | null {
  if (item === null || item === undefined || item === '') return null;

  if (typeof item === 'object') {
    return Number(item.value ?? item.id);
  }

  return Number(item);
}
